import * as msal from "@azure/msal-browser";

const config = {
  msal: {
    auth: {
      clientId: process.env.CLIENT_ID,
      authority:
        "https://login.microsoftonline.com/374f8026-7b54-4a3a-b87d-328fa26ec10d/oauth2/authorize",
      knownAuthorities: ["374f8026-7b54-4a3a-b87d-328fa26ec10d.b2clogin.com"],
      redirectUri:
        window.location.hostname === "localhost"
          ? window.location.origin + "/index.html"
          : window.location.href.replace(window.location.search, ""),
    },
    cache: {
      cacheLocation: "sessionStorage",
      storeAuthStateInCookie: false,
    },
  },
};
let msalObj = undefined;
export async function getMsalObjPromise() {
  if (msalObj === undefined) {
    msalObj = new msal.PublicClientApplication(config.msal);
  }
  await msalObj.initialize();
  await msalObj.handleRedirectPromise();
  return msalObj;
}
